/**
 * Wallet QBit SDK - 国际化
 */

export const zh = {
  walletQBit: {
    title: 'QBit 钱包',
    subtitle: '一站式数字资产投资管理',
    
    // 资产
    portfolio: {
      title: '资产总览',
      totalValue: '总资产',
      todayProfit: '今日盈亏',
      totalProfit: '累计收益',
    },
    
    // 操作
    actions: {
      deposit: '充值',
      withdraw: '提现',
      transfer: '转账',
      invest: '投资',
      redeem: '赎回',
    },
    
    // 投资产品
    products: {
      title: '理财产品',
      all: '全部',
      flexible: '活期',
      fixed: '定期',
      staking: '质押',
      apy: '年化收益率',
      minAmount: '起投金额',
      term: '期限',
      subscribe: '申购',
    },
    
    // 我的投资
    investments: {
      title: '我的投资',
      holding: '持有中',
      redeemed: '已赎回',
      earning: '收益',
    },
    
    // DeFi
    defi: {
      title: 'DeFi',
      pools: '流动性池',
      addLiquidity: '添加流动性',
      removeLiquidity: '移除流动性',
      stake: '质押',
      unstake: '取消质押',
    },
    
    // 交易
    transactions: {
      title: '交易记录',
      deposit: '充值',
      withdraw: '提现',
      transfer: '转账',
      invest: '投资',
      earning: '收益',
    },
    
    // 提醒
    alerts: {
      title: '价格提醒',
      create: '创建提醒',
      priceAbove: '价格高于',
      priceBelow: '价格低于',
    },
    
    // 消息
    messages: {
      depositSuccess: '充值成功',
      withdrawSuccess: '提现已提交',
      investSuccess: '投资成功',
      redeemSuccess: '赎回成功',
    },
    
    // 错误
    errors: {
      insufficientBalance: '余额不足',
      minAmountRequired: '低于最小投资额',
      withdrawFailed: '提现失败',
    },
  },
};

export const en = {
  walletQBit: {
    title: 'QBit Wallet',
    subtitle: 'One-stop digital asset investment management',
    
    portfolio: {
      title: 'Portfolio',
      totalValue: 'Total Value',
      todayProfit: 'Today P&L',
      totalProfit: 'Total Profit',
    },
    
    actions: {
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      transfer: 'Transfer',
      invest: 'Invest',
      redeem: 'Redeem',
    },
    
    products: {
      title: 'Investment Products',
      all: 'All',
      flexible: 'Flexible',
      fixed: 'Fixed',
      staking: 'Staking',
      apy: 'APY',
      minAmount: 'Min Amount',
      term: 'Term',
      subscribe: 'Subscribe',
    },
    
    investments: {
      title: 'My Investments',
      holding: 'Holding',
      redeemed: 'Redeemed',
      earning: 'Earnings',
    },
    
    defi: {
      title: 'DeFi',
      pools: 'Liquidity Pools',
      addLiquidity: 'Add Liquidity',
      removeLiquidity: 'Remove Liquidity',
      stake: 'Stake',
      unstake: 'Unstake',
    },
    
    transactions: {
      title: 'Transactions',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      transfer: 'Transfer',
      invest: 'Investment',
      earning: 'Earning',
    },
    
    alerts: {
      title: 'Price Alerts',
      create: 'Create Alert',
      priceAbove: 'Price Above',
      priceBelow: 'Price Below',
    },
    
    messages: {
      depositSuccess: 'Deposit successful',
      withdrawSuccess: 'Withdrawal submitted',
      investSuccess: 'Investment successful',
      redeemSuccess: 'Redemption successful',
    },
    
    errors: {
      insufficientBalance: 'Insufficient balance',
      minAmountRequired: 'Below minimum amount',
      withdrawFailed: 'Withdrawal failed',
    },
  },
};

export const ja = {
  "walletQBit": {
    "title": "QBitウォレット",
    "subtitle": "ワンストップのデジタル資産投資管理",
    "portfolio": {
      "title": "ポートフォリオ",
      "totalValue": "総資産",
      "todayProfit": "今日の損益",
      "totalProfit": "累計収益"
    },
    "actions": {
      "deposit": "入金",
      "withdraw": "出金",
      "transfer": "送金",
      "invest": "投資",
      "redeem": "償還"
    },
    "products": {
      "title": "投資商品",
      "all": "すべて",
      "flexible": "普通",
      "fixed": "定期",
      "staking": "ステーキング",
      "apy": "年換算収益率",
      "minAmount": "最小投資額",
      "term": "期間",
      "subscribe": "購読"
    },
    "investments": {
      "title": "マイ投資",
      "holding": "保有中",
      "redeemed": "償還済み",
      "earning": "収益"
    },
    "defi": {
      "title": "DeFi",
      "pools": "流動性プール",
      "addLiquidity": "流動性の追加",
      "removeLiquidity": "流動性の削除",
      "stake": "ステーキング",
      "unstake": "ステーキング解除"
    },
    "transactions": {
      "title": "取引履歴",
      "deposit": "入金",
      "withdraw": "出金",
      "transfer": "送金",
      "invest": "投資",
      "earning": "収益"
    },
    "alerts": {
      "title": "価格アラート",
      "create": "アラート作成",
      "priceAbove": "価格が次の値を超えた時",
      "priceBelow": "価格が次の値を下回った時"
    },
    "messages": {
      "depositSuccess": "入金に成功しました",
      "withdrawSuccess": "出金が申請されました",
      "investSuccess": "投資に成功しました",
      "redeemSuccess": "償還に成功しました"
    },
    "errors": {
      "insufficientBalance": "残高不足",
      "minAmountRequired": "最小投資額未満",
      "withdrawFailed": "出金失敗"
    }
  }
};

export const ko = {
  "walletQBit": {
    "title": "QBit 지갑",
    "subtitle": "원스톱 디지털 자산 투자 관리",
    "portfolio": {
      "title": "포트폴리오",
      "totalValue": "총 자산",
      "todayProfit": "오늘의 손익",
      "totalProfit": "누적 수익"
    },
    "actions": {
      "deposit": "입금",
      "withdraw": "출금",
      "transfer": "이체",
      "invest": "투자",
      "redeem": "상환"
    },
    "products": {
      "title": "투자 상품",
      "all": "전체",
      "flexible": "수시",
      "fixed": "정기",
      "staking": "스테이킹",
      "apy": "연이율",
      "minAmount": "최소 금액",
      "term": "기간",
      "subscribe": "청약"
    },
    "investments": {
      "title": "내 투자",
      "holding": "보유 중",
      "redeemed": "상환됨",
      "earning": "수익"
    },
    "defi": {
      "title": "DeFi",
      "pools": "유동성 풀",
      "addLiquidity": "유동성 추가",
      "removeLiquidity": "유동성 제거",
      "stake": "스테이킹",
      "unstake": "스테이킹 해제"
    },
    "transactions": {
      "title": "거래 기록",
      "deposit": "입금",
      "withdraw": "출금",
      "transfer": "이체",
      "invest": "투자",
      "earning": "수익"
    },
    "alerts": {
      "title": "가격 알림",
      "create": "알림 생성",
      "priceAbove": "가격이 다음보다 높음",
      "priceBelow": "가격이 다음보다 낮음"
    },
    "messages": {
      "depositSuccess": "입금 성공",
      "withdrawSuccess": "출금 신청됨",
      "investSuccess": "투자 성공",
      "redeemSuccess": "상환 성공"
    },
    "errors": {
      "insufficientBalance": "잔액 부족",
      "minAmountRequired": "최소 금액 미만",
      "withdrawFailed": "출금 실패"
    }
  }
};

export default { zh, en, ja, ko };
